import { render, staticRenderFns } from "./contractWorkloadEstimateDetail.vue?vue&type=template&id=4b19f754&scoped=true&"
import script from "./contractWorkloadEstimateDetail.vue?vue&type=script&lang=js&"
export * from "./contractWorkloadEstimateDetail.vue?vue&type=script&lang=js&"
import style0 from "./contractWorkloadEstimateDetail.vue?vue&type=style&index=0&id=4b19f754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19f754",
  null
  
)

export default component.exports